import React, { useState, useEffect } from 'react';

import {
  getAllAuthorsWithPostCount,
  createAuthor,
  updateAuthor,
  deleteAuthor,
} from '../../../api/services/blogPostAuthorsApi';

import useEntityModals from '../../../hooks/admin/useEntityModals/useEntityModals';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminAuthorCard from '../../../components/admin/cards/AdminAuthorCard/AdminAuthorCard';
import BlogPostAuthorModal from '../../../components/admin/modals/BlogPostAuthorModal/BlogPostAuthorModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminBlogAuthors.css';

const AdminBlogAuthors = () => {
  const {
    selected,
    isEditModalOpen,
    isDeleteModalOpen,
    editModalMode,
    editModalError,
    setEditModalError,
    openAddModal,
    openEditModal,
    closeEditModal,
    openDeleteOrInfoModal,
    closeDeleteModal,
  } = useEntityModals();

  const [authors, setAuthors] = useState([]);

  const fetchAuthors = async () => {
    const authorsWithPostCount = await getAllAuthorsWithPostCount();
    setAuthors(authorsWithPostCount);
  };

  useEffect(() => {
    fetchAuthors();
  }, []);

  /* ---------- Submit ---------- */

  const handleAuthorSubmit = async (formData) => {
    try {
      setEditModalError('');

      if (editModalMode === 'edit') {
        await updateAuthor(selected._id, formData);
        alert('Author updated successfully!');
      } else {
        await createAuthor(formData);
        alert('Author created successfully!');
      }

      await fetchAuthors();
      closeEditModal();
    } catch (error) {
      console.error('Submit failed:', error);

      setEditModalError(
        error.message || 'Something went wrong.  Please try again.',
      );
    }
  };

  /* ---------- Delete ---------- */

  const onAuthorConfirmDelete = async () => {
    try {
      await deleteAuthor(selected._id);

      await fetchAuthors();
      closeDeleteModal();

      alert(`Deleted! ${selected.name} deleted successfully!`);
    } catch (err) {
      console.error(err);
      alert('Failed to delete author.');
    }
  };

  return (
    <>
      <div className='admin-blog-metadata-authors-container'>
        <div className='admin-blog-metadata-title-add-author-container'>
          <h1 className='admin-blog-metadata-authors-title'>Authors</h1>

          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={openAddModal}
          >
            Add Author
          </ContentChangeButton>
        </div>

        <div className='admin-blog-metadata-author-cards-container'>
          {authors.map((a) => (
            <AdminAuthorCard
              key={a._id}
              authorWithPostCount={a}
              onEditClickHandler={openEditModal}
              onDeleteClickHandler={openDeleteOrInfoModal}
            />
          ))}
        </div>
      </div>

      {/* Modals */}
      {isEditModalOpen && (
        <BlogPostAuthorModal
          onClose={closeEditModal}
          onSubmit={handleAuthorSubmit}
          blogPostAuthor={selected}
          mode={editModalMode}
          errorMsg={editModalError}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={closeDeleteModal}
          onConfirm={onAuthorConfirmDelete}
          deleteItemTitle={`${selected?.name}`}
        />
      )}
    </>
  );
};

export default AdminBlogAuthors;
